import React, { FC } from 'react';
import classnames from 'classnames';
import snakkeboble from './images/snakkeboble.svg';
import './customer-feedback-card.scss';

export interface CustomerFeedbackCardProps {
    title: string;
    text: string;
    /**
     * Link to feedback-form
     */
    url: string;
    /**
     * Your own class name
     */
    className?: string;
}

const CustomerFeedbackCard: FC<CustomerFeedbackCardProps> = ({ text, url, title, className }) => (
    <a
        href={url}
        className={classnames('customer-feedback-link', className)}
        target="_blank"
        rel="noopener noreferrer"
        id="customer-feedback-card"
    >
        <div>
            <p>{title}</p>
            <p className="customer-feedback-link__description">{text}</p>
        </div>
        <img src={snakkeboble} alt="" />
    </a>
);

export default CustomerFeedbackCard;
